import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import style from "./ExpeditorActionsTab.module.scss";
import { File } from "../../../../../../../services";
import CustomInput from "../../../../../../custom/custom-input/CustomInput";
import CustomButton from "../../../../../../custom/custom-button/CustomButton";

const ExpeditorDocumentUpload = ({ order, refreshDocuments }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [documentName, setDocumentName] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setDocumentName("");
  }, [order?.id]);

  const handleChooseFile = () => {
    if (!documentName.trim()) {
      toast.error(t("orderInfo.documentsTab.docNameRequired"));
      return;
    }
    fileInputRef.current?.click();
  };

  const handleFileSelected = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file || !order?.id) return;

    const trimmedName = documentName.trim();
    if (!trimmedName) {
      toast.error(t("orderInfo.documentsTab.docNameRequired"));
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("FileName", file.name);
    formData.append("orderId", order.id);
    formData.append("name", trimmedName);
    formData.append("Name", trimmedName);
    formData.append("type", 7);

    try {
      setIsUploading(true);
      await File.addOrderDoc(formData);
      toast.success(t("orderInfo.documentsTab.uploadSuccess"));
      setDocumentName("");
      await refreshDocuments?.();
    } catch (error) {
      console.error(error);
      toast.error(t("orderInfo.documentsTab.uploadError"));
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className={style.card}>
      <div className={style.topbar}>
        <span className={style.topbar_title}>
          {t("orderInfoExpeditor.actions.attachDocuments")}
        </span>
      </div>
      <div className={style.docs_row}>
        <div className={style.docs_input_wrap}>
          <CustomInput
            value={documentName}
            isBgGray
            labelText={t("orderInfo.documentsTab.docNameLabel")}
            placeholder={t("orderInfo.documentsTab.docNamePlaceholder")}
            onChangeValue={setDocumentName}
          />
        </div>
        <div className={style.docs_file_btn}>
          <CustomButton
            text={t("orderInfoExpeditor.actions.chooseFile")}
            isNavy
            onClick={handleChooseFile}
            isLoading={isUploading}
            disabled={isUploading}
          />
        </div>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        data-testid="aviation-expeditor-action-file-input"
        style={{ display: "none" }}
        onChange={handleFileSelected}
      />
    </div>
  );
};

export default ExpeditorDocumentUpload;

